import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const approvedProjects = [
  {
    id: 'RAJUK-PROJ-001',
    name: 'Purbachal New Town Phase 3',
    developer: 'RAJUK (Government)',
    rajukApproval: 'RAJUK-MA-2022-0001',
    buildingPermit: 'BP-DHA-2022-00456',
    landUsePermit: 'LUP-2022-00789',
    type: 'Residential Township',
    plots: 8500,
    soldPlots: 6200,
    priceRange: '৳ 45L – ৳ 1.8Cr',
    paymentPlan: '30/70',
    handover: 'Q2 2026',
    progress: 62,
    allApproved: true,
    city: 'Dhaka'
  },
  {
    id: 'RAJUK-PROJ-002',
    name: 'Bashundhara R/A Extension',
    developer: 'Bashundhara Group',
    rajukApproval: 'RAJUK-MA-2023-0045',
    buildingPermit: 'BP-DHA-2023-00891',
    landUsePermit: 'LUP-2023-01234',
    type: 'Residential Complex',
    plots: 1200,
    soldPlots: 890,
    priceRange: '৳ 80L – ৳ 3.5Cr',
    paymentPlan: '20/80',
    handover: 'Q4 2025',
    progress: 78,
    allApproved: true,
    city: 'Dhaka'
  },
  {
    id: 'CDA-PROJ-001',
    name: 'Agrabad Commercial Hub',
    developer: 'Chittagong Development Authority',
    rajukApproval: 'CDA-MA-2023-0012',
    buildingPermit: 'BP-CTG-2023-00234',
    landUsePermit: 'Pending',
    type: 'Commercial Complex',
    plots: 320,
    soldPlots: 145,
    priceRange: '৳ 1.2Cr – ৳ 6Cr',
    paymentPlan: '40/60',
    handover: 'Q1 2027',
    progress: 24,
    allApproved: false,
    city: 'Chittagong'
  }
];

const PropertyVerification = () => {
  const [selected, setSelected] = useState(null);
  const [cityFilter, setCityFilter] = useState('All');

  const filtered = approvedProjects?.filter(p => cityFilter === 'All' || p?.city === cityFilter);

  return (
    <div className="rounded-2xl p-6" style={{ background: 'rgba(10,22,40,0.9)', border: '1px solid rgba(0,180,80,0.2)' }}>
      <div className="flex items-center gap-3 mb-6">
        <div className="w-10 h-10 rounded-xl flex items-center justify-center" style={{ background: 'rgba(0,180,80,0.1)', border: '1px solid rgba(0,180,80,0.3)' }}>
          <Icon name="MapPin" size={20} color="#00B450" />
        </div>
        <div>
          <h3 className="text-lg font-bold" style={{ color: '#E8F4FF' }}>Dhaka & Chittagong Property Verification</h3>
          <p className="text-xs" style={{ color: '#6B9EC4' }}>RAJUK & CDA master approvals, land use permits & sales authorization</p>
        </div>
      </div>

      {/* City Filter */}
      <div className="flex gap-2 mb-5">
        {['All', 'Dhaka', 'Chittagong']?.map(city => (
          <button
            key={city}
            onClick={() => setCityFilter(city)}
            className="px-3 py-1.5 rounded-lg text-xs font-medium transition-all"
            style={{
              background: cityFilter === city ? 'rgba(0,180,80,0.15)' : 'rgba(0,180,80,0.04)',
              border: `1px solid ${cityFilter === city ? 'rgba(0,180,80,0.5)' : 'rgba(0,180,80,0.15)'}`,
              color: cityFilter === city ? '#00B450' : '#6B9EC4'
            }}
          >
            {city === 'Dhaka' ? '🏙️ Dhaka' : city === 'Chittagong' ? '⚓ Chittagong' : 'All Cities'}
          </button>
        ))}
      </div>

      <div className="space-y-3">
        {filtered?.map((proj, i) => (
          <div key={i}>
            <button
              onClick={() => setSelected(selected?.id === proj?.id ? null : proj)}
              className="w-full text-left p-4 rounded-xl transition-all"
              style={{ background: selected?.id === proj?.id ? 'rgba(0,180,80,0.1)' : 'rgba(0,180,80,0.04)', border: `1px solid ${selected?.id === proj?.id ? 'rgba(0,180,80,0.4)' : 'rgba(0,180,80,0.12)'}` }}
            >
              <div className="flex items-start justify-between gap-2">
                <div>
                  <div className="flex items-center gap-2 mb-1">
                    <span className="font-semibold text-sm" style={{ color: '#E8F4FF' }}>{proj?.name}</span>
                    <span className="text-xs px-1.5 py-0.5 rounded" style={{ background: 'rgba(0,180,80,0.08)', color: '#00B450', fontSize: 10 }}>{proj?.city}</span>
                  </div>
                  <div className="text-xs" style={{ color: '#6B9EC4' }}>{proj?.developer} · {proj?.type} · {proj?.plots} plots</div>
                </div>
                <span className="text-xs px-2 py-1 rounded-full flex-shrink-0" style={proj?.allApproved ? { background: 'rgba(34,197,94,0.1)', color: '#22c55e' } : { background: 'rgba(245,158,11,0.1)', color: '#f59e0b' }}>
                  {proj?.allApproved ? '✓ All Approved' : '⚠ Pending'}
                </span>
              </div>
              <div className="mt-2">
                <div className="flex justify-between text-xs mb-1" style={{ color: '#6B9EC4' }}>
                  <span>Construction Progress</span>
                  <span style={{ color: '#00B450' }}>{proj?.progress}%</span>
                </div>
                <div className="h-1.5 rounded-full" style={{ background: 'rgba(255,255,255,0.1)' }}>
                  <div className="h-1.5 rounded-full" style={{ width: `${proj?.progress}%`, background: '#00B450' }} />
                </div>
              </div>
            </button>

            {selected?.id === proj?.id && (
              <div className="mt-2 p-4 rounded-xl" style={{ background: 'rgba(0,180,80,0.05)', border: '1px solid rgba(0,180,80,0.15)' }}>
                <div className="grid grid-cols-2 gap-3 mb-4">
                  {[
                    { label: 'RAJUK/CDA Approval', value: proj?.rajukApproval },
                    { label: 'Building Permit', value: proj?.buildingPermit },
                    { label: 'Land Use Permit', value: proj?.landUsePermit },
                    { label: 'Price Range', value: proj?.priceRange },
                    { label: 'Payment Plan', value: proj?.paymentPlan },
                    { label: 'Handover', value: proj?.handover },
                    { label: 'Plots Sold', value: `${proj?.soldPlots} / ${proj?.plots}` },
                    { label: 'Project Type', value: proj?.type }
                  ]?.map((item, j) => (
                    <div key={j} className="p-2 rounded-lg" style={{ background: 'rgba(10,22,40,0.6)' }}>
                      <div className="text-xs" style={{ color: '#6B9EC4' }}>{item?.label}</div>
                      <div className="text-sm font-medium" style={{ color: item?.value === 'Pending' ? '#f59e0b' : '#E8F4FF' }}>{item?.value}</div>
                    </div>
                  ))}
                </div>
                <div className="flex gap-2">
                  <button className="flex-1 py-2 rounded-lg text-xs font-medium" style={{ background: 'rgba(0,180,80,0.1)', border: '1px solid rgba(0,180,80,0.3)', color: '#00B450' }}>
                    View RAJUK Documents
                  </button>
                  <button className="flex-1 py-2 rounded-lg text-xs font-medium" style={{ background: 'rgba(0,180,80,0.1)', border: '1px solid rgba(0,180,80,0.3)', color: '#00B450' }}>
                    Download Permit
                  </button>
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default PropertyVerification;
